import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { DeleteRequestsComponent } from './delete-requests/delete-requests.component';
import { TestAnalyticsComponent } from './test-analytics/test-analytics.component';
import { DetailsAnswerSheetComponent } from './details-answer-sheet/details-answer-sheet.component';
import { SupportDetailsComponent } from './support-details/support-details.component';
import { JobApplicationsComponent } from './job-applications/job-applications.component';
import { RoleGuard } from 'src/app/core/guards/role.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: UsersComponent,
    canActivate: [RoleGuard],
    data: { key: 'user' },
  },
  {
    path: 'detail/:id',
    component: UserDetailsComponent,
    canActivate: [RoleGuard],
    data: { key: 'user' },
  },
  {
    path: 'delete-requests',
    component: DeleteRequestsComponent,
    canActivate: [RoleGuard],
    data: { key: 'delete-requests' },
  },
  {
    path: 'support-details',
    component: SupportDetailsComponent,
    canActivate: [RoleGuard],
    data: { key: 'support-details' },
  },
  {
    path: 'attempted-tests-analytics',
    component: TestAnalyticsComponent,
    canActivate: [RoleGuard],
    data: { key: 'attempted-tests-analytics' },
  },
  {
    path: 'detail-answer-sheet/:id',
    component: DetailsAnswerSheetComponent,
    canActivate: [RoleGuard],
    data: { key: 'user' },
  },
  {
    path: 'job-applications',
    component: JobApplicationsComponent,
    canActivate: [RoleGuard],
    data: { key: 'job-applications' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule { }
